import { CheckIcon } from '@heroicons/react/24/solid'
import { useEffect, useState } from 'react'
import { BounceLoader, GridLoader } from 'react-spinners'
import { Text } from '@/components/base/text'
import clsx from 'clsx'

const lines = [
  ['Packing the truck', 'Truck packed'],
  ['Testing the power', 'Power is on'],
  ['Flying the PA', 'PA is flown'],
  ['Rigging the lights', 'Lights are rigged'],
  ['Staring at the video wall', 'Video wall is bright'],
  ['Grabbing lunch', 'Hunger has been satisfied'],
  ['Finding the artist', 'Artist has gone walkabouts'],
  ['Soundchecking', 'Everything is loud'],
  ['Waiting for doors'],
]

export const FullPage = () => {
  const [currentLoadingText, setCurrentLoadingText] = useState(0)

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setCurrentLoadingText(currentLoadingText + 1)
      },
      Math.floor(500 + (Math.random() * 2000))
    )
    if (currentLoadingText >= lines.length - 1) clearInterval(timer)
  }, [currentLoadingText])

  return (
    <div className="flex flex-row grow justify-center items-center">
      <div className="flex flex-col gap-12 items-center">
        <div className="flex flex-col gap-2 text-gray-500 items-center">
          { lines.map((line, i) => (
            <div className="flex flex-row gap-2 items-center" key={ i }>
              <span
                className={ clsx(
                  i <= currentLoadingText ? '' : 'hidden',
                  i == currentLoadingText ? 'text-xl text-zinc-950 dark:text-white pt-4' : 'text-sm'
                ) }
              >
                { i >= currentLoadingText ? line[0] : line[1] }
                { i == currentLoadingText ? '...' : '' }
              </span>
              <CheckIcon
                className={ `h-6 w-6 ${i < currentLoadingText ? '' : 'hidden'}` }
              />
            </div>
          )) }
        </div>
        <GridLoader color="lightgray" size={ 15 } />
      </div>
    </div>
  )
}

export const Inline = () => {
  return (
    <div className="h-full w-full flex flex-row justify-center items-center gap-6">
      <BounceLoader color="lightgray" size={ 16 } />
      <Text>Thinking about it...</Text>
    </div>
  )
}
